import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=83f3bda2&"
import script from "./RadioItem.vue?vue&type=script&lang=ts&"
export * from "./RadioItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports